import { Component } from '@angular/core';

@Component({
  selector: 'app-gb-aside',
  templateUrl: './gb-aside.component.html',
  styleUrls: ['./gb-aside.component.scss']
})
export class GbAsideComponent {

}
